module.exports = __webpack_public_path__ + "static/lamex_restaurant_story_thumbnail-9ac4449870a25126b35ae33627cedecc.png";